import React, { RefObject } from 'react';
import { Upload, FileText, Loader } from 'lucide-react';

interface UploadStepProps {
  fileInputRef: RefObject<HTMLInputElement>;
  onFileUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isProcessing: boolean;
}

const UploadStep: React.FC<UploadStepProps> = ({
  fileInputRef,
  onFileUpload,
  isProcessing
}) => {
  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-white rounded-xl shadow-lg p-8">
        <div className="text-center">
          <div className="mx-auto w-24 h-24 bg-blue-50 rounded-full flex items-center justify-center mb-6">
            <Upload className="w-10 h-10 text-blue-600" />
          </div>

          <h2 className="text-xl font-semibold text-gray-900 mb-4">Upload CSV File</h2>
          <p className="text-gray-600 mb-6">
            Select a CSV file containing your metadata. The file should have columns for Filename, Title, Description, and Keywords.
          </p>

          <input
            ref={fileInputRef}
            type="file"
            accept=".csv"
            onChange={onFileUpload}
            className="hidden"
          />

          <button
            onClick={() => fileInputRef.current?.click()}
            disabled={isProcessing}
            className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors disabled:opacity-50"
          >
            {isProcessing ? (
              <Loader className="w-5 h-5 mr-2 animate-spin" />
            ) : (
              <FileText className="w-5 h-5 mr-2" />
            )}
            {isProcessing ? 'Processing...' : 'Choose CSV File'}
          </button>

          <div className="mt-6 space-y-4">
            {/* CSV Format Info */}
            <div className="text-sm text-gray-500">
              <p className="mb-2">Expected CSV format:</p>
              <code className="bg-gray-100 px-2 py-1 rounded text-xs">
                Filename,Title,Description,Keywords
              </code>
            </div>

            {/* Limits Info */}
            <div className="text-sm text-gray-500 border-t border-gray-200 pt-4">
              <p className="font-medium text-gray-700">
                Maximum file size: <strong>10MB</strong> | Maximum rows: <strong>1,000</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadStep;

